import type { ComponentProps } from "react";
import PWAPrompt from "react-ios-pwa-prompt";

import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { NotificationsProvider } from "react-migration/domains/notifications/NotificationsProvider";
import { OfflineIndicator } from "react-migration/domains/nav/components/Banners/OfflineIndicator";

import { NavbarDesktop } from "./components/NavbarDesktop";
import { NavbarMobile } from "./components/NavbarMobile";

export const NavbarLayout = ({ activeRoute, children }: ComponentProps<"div" & { activeRoute: string }>) => {
  const { t } = useTranslation();

  return (
    <NotificationsProvider>
      <div className="hidden relative md:flex">
        <NavbarDesktop activeRoute={activeRoute}>{children}</NavbarDesktop>
      </div>
      <div className="flex relative md:hidden z-10 rounded-lg">
        <PWAPrompt
          copyTitle={t("nav.pwa.title")}
          copySubtitle={t("nav.pwa.subtitle")}
          copyDescription={t("nav.pwa.description")}
          appIconPath="img/pwa/icon-96x96.png"
          timesToShow={5}
        />
        <NavbarMobile activeRoute={activeRoute} />
      </div>
      <OfflineIndicator />
    </NotificationsProvider>
  );
};
